export * from './baMenu.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baMenu/index.ts